import * as actionTypes from '../actions/actionTypes';

const initialState = {
  loading: false,
  isIntegrated: false,
  accountIntegrations: [],
  contacts: [],
  tickets: [],
  /** Set specific contactId to be display for Saleforce integrations */
  salesforceSpecificExternalId: null,
};

const integrations = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ENABLED_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        accountIntegrations: action.payload.accountIntegrations,
        isIntegrated: action.payload.isIntegrated,
      };
    case actionTypes.FETCH_ENABLED_INTEGRATIONS:
      return {
        ...state,
        isIntegrated: action.payload.isIntegrated,
      };
    case actionTypes.FETCH_CONTACTS_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        contacts: [...action.payload.contacts],
      };
    case actionTypes.STORE_CONTACTS_INTEGRATIONS:
      return {
        ...state,
        contacts: [...state.contacts, ...action.payload.contacts],
      };

    case actionTypes.UPDATE_CONTACTS_CALL_SYNC_WITH_CRM:
      return {
        ...state,
        contacts: [...action.payload],
      };
    case actionTypes.CLEAR_CONTACTS_INTEGRATIONS:
      return {
        ...state,
        contacts: [
          ...state.contacts.filter(e => e.callId !== action.payload.callId),
        ],
      };
    case actionTypes.RESET_INTEGRATIONS_CONTACTS:
      return {
        ...state,
        contacts: [],
      };
    case actionTypes.STORE_TICKETS_INTEGRATIONS:
      return {
        ...state,
        tickets: [...state.tickets, ...action.payload.tickets],
      };
    case actionTypes.UPDATE_INTEGRATIONS_ORDER_PREFERENCE:
      return {
        ...state,
        accountIntegrations: action.payload,
      };
    case actionTypes.SET_SALESFORCE_DISPLAY_SPECIFIC_EXTERNAL_ID:
      return {
        ...state,
        salesforceSpecificExternalId: action.externalId,
      };
    default:
      return {
        ...state,
      };
  }
};

export default integrations;
